export default __webpack_public_path__ + "static/media/WNo.7-4.f9e219a5.jpg";